import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-matched",
  "use": "status-matched-usage",
  "viewBox": "0 0 58.34 58.34",
  "content": "<symbol viewBox=\"0 0 58.34 58.34\" id=\"status-matched\"><circle cx=\"29.17\" cy=\"29.17\" r=\"29.17\" /><path d=\"M15.67 32.55h27v6.75h-27zm0-13.5v6.75h27v-6.75z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/status-matched.svg
// module id = LRNL
// module chunks = 1